import { TFAQs } from '../../../Common/FAQS';

export const DETAILED_STEP_FAQs: Record<string, TFAQs> = {
  linkPanPreFill: [
    {
      header: '1. How to Link PAN in Cleartax?',
      content: (
        <p>
          <ul className="pl-4 list-disc">
            <li>Log in to your ClearTax account. </li>
            <li>Enter your PAN number and associated phone number.</li>
            <li>You will receive an OTP on your phone for verification.</li>
            <li>Enter the OTP to complete the linking process.</li>
            <li>
              Your PAN will be successfully linked in ClearTax for easy tax
              filing.
            </li>
          </ul>
        </p>
      ),
    },
    {
      header: '2. How to do Prefill in Cleartax?',
      content: (
        <p>
          <ul className="pl-4 list-disc">
            <li>Log in to your ClearTax account.</li>
            <li>Enter you PAN and DOB.</li>
            <li>Enter the OTP you receive on your RMN.</li>
            <li>Your data is prefilled to cleartax within minutes.</li>
          </ul>
        </p>
      ),
    },
  ],
  form16: [
    {
      header: '1. What is Form 16?',
      content: (
        <p>
          Form 16 is a document provided by an employer to an employee that
          contains details of the salary paid to the employee and the TDS (Tax
          Deducted at Source) deducted on that salary. <br />
          It is an important document for filing income tax returns as it helps
          in calculating the total income earned and the tax liability of the
          employee.
        </p>
      ),
    },
    {
      header: '2. Who gets form 16 to file ITR?',
      content: (
        <p>Form 16 is useful for employees to report their TDS on salary.</p>
      ),
    },
  ],
  personalInfo: [
    {
      header:
        '1. What information is to be uploaded in the Personal Information tab?',
      content: (
        <p>
          In the Personal Information tab of ClearTax, you should upload the
          following information:
          <ul className="pl-4 list-disc">
            <li>Identification details</li>
            <li>Contact details</li>
            <li>Residential details</li>
            <li>Bank details</li>
          </ul>
        </p>
      ),
    },
    {
      header: '2. Why are bank details required?',
      content: (
        <p>
          Bank details are necessary for processing any income tax refunds that
          you may be eligible for.
        </p>
      ),
    },
  ],
  incomeSources: [
    {
      header: '1. What information should be filled in the Income Sources tab?',
      content: (
        <p>
          In the Income Sources tab of ClearTax, you should fill in details
          about the following income sources:
          <ul className="pl-4 list-disc">
            <li>Salary income</li>
            <li>Capital gains</li>
            <li>Business and professional income</li>
            <li>Interest income</li>
            <li>Dividend income</li>
            <li>Rental and house property income</li>
            <li>Crypto income</li>
          </ul>
        </p>
      ),
    },
  ],
  taxSaving: [
    {
      header: '1. What are the type of tax savings in ITR filing?',
      content: (
        <p>
          In ITR filings, you can avail various types of tax savings deductions,
          including:
          <ul className="pl-4 list-disc">
            <li>
              Investments in PPF, Life Insurance, ELSS, etc. under Section 80C
            </li>
            <li>Medical insurance premiums under Section 80D</li>
            <li>Deductions for disabled dependents under Section 80DD</li>
            <li>Education loan interest under Section 80E</li>
            <li>Donations to charitable institutions under Section 80G</li>
          </ul>
        </p>
      ),
    },
  ],
  taxSummaryDeclaration: [
    {
      header: '1. What is Tax Summary',
      content: (
        <p>
          The Tax Summary page in Cleartax summarises all your tax details and
          gives you a detailed view of all your tax liabilities and ways to save
          taxes.
        </p>
      ),
    },
  ],
  eVerification: [
    {
      header: '1. Why is e-verification necessary in ITR filing?',
      content: (
        <p>
          E-verification in ClearTax is necessary for the following reasons:
          <ul className="pl-4 list-disc">
            <li>
              Authentication: E-verification ensures the authenticity of your
              income tax return filing by electronically verifying the details
              provided.
            </li>
            <li>
              Compliance: It is a mandatory step to complete the tax filing
              process and comply with income tax regulations.
            </li>
            <li>
              Convenience: E-verification eliminates the need for physical
              signatures or documents, making the verification process quick and
              hassle-free.
            </li>
          </ul>
        </p>
      ),
    },
    {
      header: '2. Who gets form 16 to file ITR?',
      content: (
        <p>Form 16 is useful for employees to report their TDS on salary.</p>
      ),
    },
  ],
  checkItrStatus: [],
};
